@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<app-navbar></app-navbar>

<div class="privacy-policy" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h1>{{ 'policy.title' | translate }}</h1>

    <h2>{{ 'policy.introduction.title' | translate }}</h2>
    <p>{{ 'policy.introduction.content' | translate }}</p>

    <h2>{{ 'policy.information_collected.title' | translate }}</h2>
    <p>{{ 'policy.information_collected.content' | translate }}</p>
    <ul>
        <li>{{ 'policy.information_collected.name' | translate }}</li>
        <li>{{ 'policy.information_collected.mail' | translate }}</li>
        <li>{{ 'policy.information_collected.address' | translate }}</li>
        <li>{{ 'policy.information_collected.phone' | translate }}</li>
        <li>{{ 'policy.information_collected.payment_method' | translate }}</li>
    </ul>

    <h2>{{ 'policy.no_personal_information.title' | translate }}</h2>
    <p>{{ 'policy.no_personal_information.content' | translate }}</p>
    <ul>
        <li>{{ 'policy.no_personal_information.ip' | translate }}</li>
        <li>{{ 'policy.no_personal_information.navigator' | translate }}</li>
        <li>{{ 'policy.no_personal_information.history' | translate }}</li>
        <li>{{ 'policy.no_personal_information.visite_date' | translate }}</li>
    </ul>

    <h2>{{ 'policy.use_of_information.title' | translate }}</h2>
    <p>{{ 'policy.use_of_information.content' | translate }}</p>
    <ul>
        <li>{{ 'policy.use_of_information.improving_services' | translate }}</li>
        <li>{{ 'policy.use_of_information.process_payments' | translate }}</li>
        <li>{{ 'policy.use_of_information.communicating' | translate }}</li>
        <li>{{ 'policy.use_of_information.personalize_your_experience' | translate }}</li>
        <li>{{ 'policy.use_of_information.analyze' | translate }}</li>
    </ul>

    <h2>{{ 'policy.disclosure_of_information.title' | translate }}</h2>
    <p>{{ 'policy.disclosure_of_information.content' | translate }}</p>
    <ul>
        <li>{{ 'policy.disclosure_of_information.with_your_consent' | translate }}</li>
        <li>{{ 'policy.disclosure_of_information.comply_with_law' | translate }}</li>
        <li>{{ 'policy.disclosure_of_information.protect_our_rights' | translate }}</li>
        <li>{{ 'policy.disclosure_of_information.merger_or_acquisition' | translate }}</li>
    </ul>

    <h2>{{ 'policy.information_security.title' | translate }}</h2>
    <p>{{ 'policy.information_security.content' | translate }}</p>

    <h2>{{ 'policy.cookies.title' | translate }}</h2>
    <p>{{ 'policy.cookies.content' | translate }}</p>

    <h2>{{ 'policy.links_to_third_party_sites.title' | translate }}</h2>
    <p>{{ 'policy.links_to_third_party_sites.content' | translate }}</p>

    <h2>{{ 'policy.user_rights.title' | translate }}</h2>
    <p>{{ 'policy.user_rights.content' | translate }}</p>
    <ul>
        <li>{{ 'policy.user_rights.access_personal_information' | translate }}</li>
        <li>{{ 'policy.user_rights.update_your_information' | translate }}</li>
        <li>{{ 'policy.user_rights.request_deletion_of_your_information' | translate }}</li>
        <li>{{ 'policy.user_rights.Oppose_processing_of_information' | translate }}</li>
    </ul>

    <h2>{{ 'policy.changes_privacy_policy.title' | translate }}</h2>
    <p>{{ 'policy.changes_privacy_policy.content' | translate }}</p>

    <h2>{{ 'policy.contact.title' | translate }}</h2>
    <p>{{ 'policy.contact.content' | translate }}</p>
    <p>{{ 'policy.contact.name' | translate }}</p>
    <ul>
        <li>{{ 'policy.contact.address.title' | translate }}</li>
        <li>{{ 'policy.contact.address.conent' | translate }}</li>
        <li>{{ 'policy.contact.address.phone' | translate }}</li>
        <li>{{ 'policy.contact.address.mail' | translate }}</li>
    </ul>

</div>